import $ from "jquery";
import "jquery.easing";

export default class MenuSlug {
  constructor(params) {
    if (!params) {
      params = {};
    }
    this.params = $.extend({
      border: "4px solid red",
      containerSelector: "#page-header-nav",
      itemsSelector: ">ul>li>a",
      mouseLeaveSelector: "li",
      currentItemSelector: ".current"
    }, params);

    this.container = null;
    this.items = null;
    this.slug = null;
  }

  run() {
    $(document).ready(() => {
      // Create the slug
      this.container = $(this.params.containerSelector)
        .css("position", "relative")
        .append(`<style>
.menu-slug-active {
  position: relative;
}

.menu-slug-active::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  border-top: ${this.params.border};
}
</style>`)
        .append("<div class=\"menu-slug\"></div>");
      this.slug = this.container.find(".menu-slug")
        .css("position", "absolute")
        .css("left", "100%")
        .css("right", "0")
        .css("top", "0")
        .css("border-top", this.params.border);
      this.items = this.container.find(this.params.itemsSelector);

      // Move slug to the current item
      const currentItem = this.items.filter(this.params.currentItemSelector);
      if (currentItem.length > 0) {
        this._animateToItem(currentItem[0]);
      }

      // Hook on to mouse events
      this.items
        .on({
          mouseenter: (event) => {
            this._animateToItem(event.delegateTarget);
          }
        });

      this.container.find(this.params.mouseLeaveSelector)
        .on({
          mouseleave: (event) => {
            setTimeout(() => {
                const target = $(event.delegateTarget);
                const hoveredItems = this.container.find(this.params.mouseLeaveSelector + ":hover");
                if (currentItem.length > 0 &&
                  target.filter(this.params.currentItemSelector).length === 0 &&
                  hoveredItems.length === 0) {
                  this._animateToItem(currentItem[0], {
                    firstStepDuration: 2000,
                    secondStepDuration: 2000,
                    easingFunction: "easeOutSine"
                  });
                }
              },
              500);
          }
        });
    });
  }

  _animateToItem(item, params) {
    if (!params) {
      params = {};
    }
    params = $.extend({
      firstStepDelay: 100,
      firstStepDuration: 500,
      secondStepDelay: 50,
      secondStepDuration: 500,
      easingFunction: "easeOutQuint"
    }, params);

    item = $(item);
    const containerOffset = this.container.offset().left;
    const itemOffset = item.offset().left;
    const newLeft = itemOffset - containerOffset;
    const newRight = (containerOffset + this.container.width()) - (itemOffset + item.width());

    var firstPropertyChange, secondPropertyChange;
    if (newLeft >= parseInt(this.slug.css("left"), 10)) {
      // Right, then left
      firstPropertyChange = { right: String(newRight) + "px" };
      secondPropertyChange = { left: String(newLeft) + "px" };
    } else {
      // Left, then right
      firstPropertyChange = { left: String(newLeft) + "px" };
      secondPropertyChange = { right: String(newRight) + "px" };
    }

    setTimeout(() => {
      this.slug
        .stop(true, false)
        .css("visibility", "visible")
        .animate(firstPropertyChange, {
          queue: false,
          duration: params.firstStepDuration,
          easing: params.easingFunction,
          complete: () => {
            item.addClass("menu-slug-active");
          }
        });

      setTimeout(() => {
        this.items.removeClass("menu-slug-active");      
        this.slug
          .animate(secondPropertyChange, {
            queue: false,
            duration: params.secondStepDuration,
            easing: params.easingFunction,
            complete: () => {
              this.slug.css("visibility", "hidden");
            }
          });
      }, params.secondStepDelay);
    }, params.firstStepDelay);

  }
}



// WEBPACK FOOTER //
// ./header/menu-slug.js